export const config = {
  indent: '    '
};